"use client";
import { Inter } from "next/font/google";
import BackToTop from "./components/backToTop";
import Script from "next/script";
import useKioskMode from "./components/checkKiosk";
const inter = Inter({ subsets: ["latin"] });

const GA_MEASUREMENT_ID = "G-PMQ6RT25DR";
const GTM_ID = "GTM-T963FMRB";
const websiteTitle = "Journey of a Soybean: How U.S. Soy Grows Opportunity";
const siteDescription =
  "Explore the many ways U.S. soybeans create value beyond the farm, and discover how the Soy Checkoff helps grow demand and sustainability at every step.";

export default function RootLayout({ children }) {
  const isKiosk = useKioskMode();
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#008242" />
        <meta name="description" content={siteDescription} />
        <meta
          name="keywords"
          content="U.S. soybeans, Soy Checkoff, soy farming, sustainable agriculture, soybean uses, animal feed, biofuels, biobased products, high oleic soybeans, soybean innovations"
        />
        <meta name="author" content="U.S. Soy" />

        <title>{websiteTitle}</title>

        {/* Open Graph (OG) / Facebook Meta Tags */}
        <meta property="og:title" content={websiteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta
          property="og:image"
          content="/assets/img/USSOY-LinkShareImage.jpg"
        />
        <meta property="og:url" content="https://soymuchmore.com" />
        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={websiteTitle} />
        <meta name="twitter:description" content={siteDescription} />
        <meta
          name="twitter:image"
          content="/assets/img/USSOY-LinkShareImage.jpg"
        />

        {/* Favicon */}
        <link rel="icon" href="/assets/img/USSOY-Favicon.png" />
        <link rel="manifest" href="/site.webmanifest" />

        {/* External Fonts & Styles */}
        <link rel="stylesheet" href="https://use.typekit.net/ppe6bqk.css" />

        {/* Google Tag Manager */}
        <Script
          id="gtm-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `,
          }}
        />

        {/* Google Analytics */}
        <Script
          strategy="afterInteractive"
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        />
        <Script
          id="google-analytics"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_MEASUREMENT_ID}', {
                page_path: window.location.pathname
              });
            `,
          }}
        />
      </head>
      <body className={inter.className}>
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          ></iframe>
        </noscript>

        {isKiosk && <BackToTop />}
        {children}
      </body>
    </html>
  );
}

export const gtagEvent = (eventName, eventParams = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, eventParams);
  } else {
    console.warn("Google Analytics not initialized");
  }
};
